import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';

export type ShareType = 'sent' | 'received';

const APP_URL = 'https://imata.app';
const HASHTAGS = 'imata,SpreadKindness';

export const getShareMessage = (type: ShareType): string => {
  if (type === 'sent') {
    return "I just spread some kindness using imata! 🎁✨ Download the app and start gifting to people around you!";
  }
  return "Someone just made my day with imata! 💝 Such an amazing way to spread kindness!";
};

export const shareToTwitter = (message: string): void => {
  const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(APP_URL)}&hashtags=${HASHTAGS}`;
  window.open(url, '_blank');
};

export const shareToFacebook = (message: string): void => {
  const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(APP_URL)}&quote=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
};

export const shareNative = async (message: string): Promise<boolean> => {
  if (Capacitor.isNativePlatform()) {
    await Share.share({
      title: 'imata',
      text: message,
      url: APP_URL,
      dialogTitle: 'Share your imata moment',
    });
    return true;
  }
  
  // Try Web Share API for browsers that support it
  if (navigator.share) {
    await navigator.share({
      title: 'imata',
      text: message,
      url: APP_URL,
    });
    return true;
  }
  
  return false;
};

export const copyToClipboard = async (message: string): Promise<void> => {
  await navigator.clipboard.writeText(`${message} ${APP_URL}`);
};
